import React from "react";
import { orientationLabel, stabilityLabel } from "./needsApplicationModel";

function n(value) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}

export default function ConfigurationPrimaryExplanation({ state, groups }) {
  const roots = n(state?.independent_root_count) ?? n(state?.root_count);
  const pathways = n(state?.pathway_count) ?? (state?.pathways?.length || 0);
  const orientation = state?.orientation || state?.resultant_orientation || "unresolved";

  const count = (name) => groups
    .filter((group) => group.orientation === name)
    .reduce((sum, group) => sum + group.pathwayCount, 0);

  const affords = count("affords");
  const constrains = count("constrains");
  const other = Math.max(0, pathways - affords - constrains);

  return (
    <section className="rr-terrain-primary-explanation">
      <div>
        <span className="v25a-eyebrow">START HERE · CURRENT CONFIGURATION</span>
        <h3>Read one configuration before comparing it</h3>
      </div>

      <p>
        This configuration materializes <b>{pathways || "—"} pathways</b>
        {roots !== null ? <> across <b>{roots} independent {roots === 1 ? "StudyRoot" : "StudyRoots"}</b></> : null}.
        Its current resultant is <b>{orientationLabel(orientation)}</b>. The visual terrain below is a metaphor for how those pathways coexist around the same stable capability.
      </p>

      <div className="rr-terrain-primary-receipts">
        <span className="affords"><b>{affords}</b>affording</span>
        <span className="constrains"><b>{constrains}</b>constraining</span>
        <span className="mixed"><b>{other}</b>mixed / unresolved</span>
        <span><b>{stabilityLabel(state?.stability_class)}</b>support class</span>
      </div>

      <small>Pathway counts describe materialized topology — not effect size, causality, study quality or moral value.</small>
    </section>
  );
}
